import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { ApiPaths } from "../../api/paths";
import CustomButton from "../../components/custom-button/CustomButton";
import CustomInput from "../../components/custom-input/CustomInput";
import useData from "../../hooks/use-data";
import useMutateData from "../../hooks/use-mutate-data";
import { CUSTOMER_CARE_EMAIL } from "../../resources/constants";
import { DocumentInfoType, DocumentType } from "../../types/document";
import { toBase64File } from "../../utils/to-base64-file";

interface FileObjectType {
  [key: string]: string | ArrayBuffer | null;
}

export default function InfoRequested() {
  const { data } = useData<DocumentInfoType[]>(ApiPaths.kycInfo);
  const { mutate, loading } = useMutateData(ApiPaths.kycInfo, {
    method: "POST",
  });
  const [initialValues, setInitialValues] = useState<DocumentType[]>([
    {
      _id: "teasuifsd",
      document_name: "Passport",
      document: "",
    },
    {
      _id: "teasuifsdasdqwe",
      document_name: "Liscence",
      document: "",
    },
    {
      _id: "qwe",
      document_name: "KYD",
      document: "",
    },
  ]);
  const [imageDocuments, setImageDocuments] = useState<FileObjectType>({});

  const formik = useFormik<DocumentType[]>({
    initialValues,
    validationSchema: Yup.array().of(
      Yup.object().shape({
        _id: Yup.string().required(),
        document_name: Yup.string().required(),
        document: Yup.string().required("Please upload a document"),
      })
    ),
    enableReinitialize: true,
    onSubmit: (values) => {
      const temp = values.map((val) => {
        return { ...val, document: imageDocuments[val.document_name] };
      });
      mutate(temp);
    },
  });

  if (data) {
    setInitialValues(data.map((d) => ({ ...d, document: "" })));
  }

  return (
    <div className="mx-auto container" style={{ maxWidth: "576px" }}>
      <div className="mb-4">
        <h2 className="primary-title">Additional Info Required</h2>
        <p>
          The following additional documents are required to complete your KYC
          verification process.
        </p>
        {CUSTOMER_CARE_EMAIL && (
          <p>
            For any queries write to us at
            {` ${CUSTOMER_CARE_EMAIL}`}
          </p>
        )}
      </div>
      <form onSubmit={formik.handleSubmit}>
        {initialValues.map((item, index) => {
          return (
            <div key={item?._id} className="mb-3">
              <CustomInput
                fieldName={`${index}.document`}
                formik={formik}
                label={item.document_name}
                onChange={(e) => {
                  if (e.target.files) {
                    formik.setFieldValue(
                      `${index}.document`,
                      e.target.files[0]
                    );
                    toBase64File(e.target.files[0], (f) => {
                      setImageDocuments((d) => ({
                        ...d,
                        [item.document_name]: f,
                      }));
                    });
                  }
                }}
                value={undefined}
                isArrayField={{
                  error: formik.errors[index]?.document,
                  touched: formik.touched[index]?.document,
                }}
              />
            </div>
          );
        })}
        <div className="d-flex justify-content-end mt-4">
          <CustomButton
            className="primary-button"
            type="submit"
            loading={loading}
          >
            Submit
          </CustomButton>
        </div>
      </form>
    </div>
  );
}
